import MerchantWarehouseView from './MerchantWarehouseView';
export default MerchantWarehouseView;
